/**
 * Converts Arabic-Indic numerals (٠-٩) to Western numerals (0-9)
 * @param value - String that may contain Arabic numerals
 * @returns String with all Arabic numerals converted to Western numerals
 */
export const convertArabicToWesternNumerals = (value: string): string => {
  if (!value) return value;

  const arabicNumerals = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
  const westernNumerals = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

  let result = value;

  arabicNumerals.forEach((arabic, index) => {
    result = result.replace(new RegExp(arabic, 'g'), westernNumerals[index]);
  });

  return result;
};

/**
 * Normalizes numeric input by converting Arabic numerals to Western numerals
 * and removing any non-numeric characters except the decimal point
 * @param value - Input value that may contain Arabic numerals
 * @returns Normalized numeric string
 */
export const normalizeNumericInput = (value: string): string => {
  if (!value) return value;

  // First convert Arabic numerals to Western numerals
  const converted = convertArabicToWesternNumerals(value);

  // Keep only digits (and optionally decimal point for future use)
  return converted.replace(/[^\d.]/g, '');
};
